var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgBooster = function SvgBooster(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Booster",
    transform: "translate(-7.882 -1.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42623",
    "data-name": "Path 42623",
    d: "M15.711,29.143a3.051,3.051,0,0,1-1.192-.3.215.215,0,0,0-.3.206l.1,1.381a.109.109,0,0,0,.175.076l.4-.3a.112.112,0,0,1,.158.027l.569.869a.111.111,0,0,0,.183,0l.569-.869a.112.112,0,0,1,.158-.027l.4.3a.109.109,0,0,0,.175-.076l.1-1.381a.214.214,0,0,0-.3-.206A3.064,3.064,0,0,1,15.711,29.143Z",
    transform: "translate(-3.832 -17.033)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42624",
    "data-name": "Path 42624",
    d: "M15.814,8.63,14.481,7.3a7.721,7.721,0,0,0-2.589-6.175A7.7,7.7,0,0,0,9.279,7.3L7.946,8.63a.222.222,0,0,0-.061.192L8.4,11.85A.214.214,0,0,0,8.724,12l1.864-1.23a2.143,2.143,0,0,0,1.308.542,2.025,2.025,0,0,0,1.28-.542L15.04,12a.215.215,0,0,0,.328-.146l.514-3.031A.237.237,0,0,0,15.814,8.63ZM11.893,5.892a.867.867,0,1,1,.853-.867A.859.859,0,0,1,11.893,5.892Z",
    transform: "translate(0)",
    fill: "#fff"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBooster, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/booster.83a5ad5f.svg";
export { ForwardRef as ReactComponent };